export default "__VITE_ASSET__QwAwXNAh__"